var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-bg-warning flix-form-group flix-text-center"},[_c('h1',{staticClass:"flix-html-h1"},[_vm._v(_vm._s(_vm.total)+" "+_vm._s(_vm.$tc('message.message', _vm.total)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }